// removed by extract-text-webpack-plugin
module.exports = {"smallScreen":"400px","mediumScreen":"900px","largeScreen":"1200px","xlargeScreen":"1500px"};


//////////////////
// WEBPACK FOOTER
// ./assets/scss/style.scss
// module id = 36
// module chunks = 0